import { IconList } from 'components/icon';
import parse from 'utils/parse';

import messages from './why-join-banner.i18n';

const makeTestId = (...ids: string[]): string => parse.toTestId('landing', 'why-join-banner', ...ids);

const testId = Object.freeze({
  component: makeTestId(),
  cardCarousel: makeTestId('card-carousel'),
  navLeft: makeTestId('nav-left'),
  navRight: makeTestId('nav-right'),
});

const translation = messages.pages.landing.whyJoinBanner.livejasmin.whyJoinUs;

const infoCards = [
  {
    key: 'earnings-card',
    title: translation.earningsCard.title,
    bullets: [
      {
        icon: IconList.groupThreeSolid,
        text: translation.earningsCard.bullet1,
      },
      {
        icon: IconList.trophySolid,
        text: translation.earningsCard.bullet2,
      },
      {
        icon: IconList.chartLinesSolid,
        text: translation.earningsCard.bullet3,
      },
    ],
  },
  {
    key: 'freedom-card',
    title: translation.freedomCard.title,
    bullets: [
      {
        icon: IconList.mobileSolid,
        text: translation.freedomCard.bullet1,
      },
      {
        icon: IconList.maskSolid,
        text: translation.freedomCard.bullet2,
      },
      {
        icon: IconList.payoutSolid,
        text: translation.freedomCard.bullet3,
      },
    ],
  },
  {
    key: 'safety-card',
    title: translation.safetyCard.title,
    bullets: [
      {
        icon: IconList.globeSolid,
        text: translation.safetyCard.bullet1,
      },
      {
        icon: IconList.tutorialSolid,
        text: translation.safetyCard.bullet2,
      },
      {
        icon: IconList.supportSolid,
        text: translation.safetyCard.bullet3,
      },
    ],
  },
];

const config = {
  defaultCardHeight: 240,
  debounceNavButtonVisibility: 300,
  numMonthsTrafficBoost: 3,
  monthlyCashPrizes: 48_000,
};

export { testId, infoCards, config };
